module.exports = __webpack_public_path__ + "assets/svg/Icons/32/timesheet-red-b53cde.svg";